import { cn } from '@ui-kit/utils';
import type { ComponentProps } from 'react';

// TODO: Integrate this in the UI kit
const InputWarningText = ({ className, ...props }: ComponentProps<'p'>) => (
  <p className={cn('text-caption-semibold text-text-warning mt-1', className)} {...props} />
);

export default InputWarningText;
